import React from 'react';
import PropTypes from 'prop-types';
import { Quote } from '../../../quotes/quote';
import ReviewQuoteInformationComponent from './ReviewQuoteInformationComponent';
import ReviewQuoteMachineComponent from './ReviewQuoteMachineComponent';
import { DealerBranch } from '../../../dealer-branches/dealerBranch';
import { DealerUserSearchResult } from '../../../dealer-users/dealerUserService';
import { ProductConfiguration } from '../../../products/productConfiguration';
import { QuoteProductConfiguration } from '../../../quotes/quoteProductConfiguration';
import QuoteWizardContext from '../../../quotes/QuoteWizardContext';
import ReviewQuoteCouplerDecisions from '../quote-products/ReviewQuoteCouplerDecisions';

export default class ReviewQuoteDetailsContainer extends React.Component {
  static contextType = QuoteWizardContext;
  static propTypes = {
    quote: PropTypes.instanceOf(Quote).isRequired,
    dealerBranch: PropTypes.instanceOf(DealerBranch).isRequired,
    dealerUsers: PropTypes.arrayOf(PropTypes.instanceOf(DealerUserSearchResult))
      .isRequired,
    amiUsers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.any.isRequired,
        label: PropTypes.string.isRequired,
      })
    ).isRequired,
    onUpdate: PropTypes.func.isRequired,
    onNewDealerUserAssigned: PropTypes.func.isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
    quoteProductConfiguration: PropTypes.instanceOf(QuoteProductConfiguration)
      .isRequired,
    onAddCoupler: PropTypes.func,
    isEditMode: PropTypes.bool.isRequired,
    onloadSharedDocuments: PropTypes.func.isRequired,
  };

  getDealerUsers = () => {
    const { dealerBranch } = this.props;
    return this.props.dealerUsers.filter((x) =>
      x.isAuthorizedForDealerBranch(dealerBranch.dealerGroupId, dealerBranch.id)
    );
  };

  getPreferredMakeIds = () => {
    return this.props.dealerBranch.preferredMakes;
  };

  render() {
    const machines = this.context.getQuoteCarrierMachines();
    const {
      quote,
      productConfiguration,
      quoteProductConfiguration,
      onAddCoupler,
      onUpdate,
      isEditMode,
      onloadSharedDocuments,
    } = this.props;
    return (
      <div className="row">
        <div className="col-md-6 ">
          <ReviewQuoteInformationComponent
            quote={quote}
            onUpdate={this.props.onUpdate}
            dealerUsers={this.getDealerUsers()}
            onNewDealerUserAssigned={this.props.onNewDealerUserAssigned}
            dealerBranch={this.props.dealerBranch}
            amiUsers={this.props.amiUsers}
            isEditMode={isEditMode}
          />
        </div>
        <div className="col-md-6 ">
          <ReviewQuoteMachineComponent
            quote={quote}
            machines={machines}
            preferredMakeIds={this.getPreferredMakeIds()}
            carriers={this.props.productConfiguration.carriers}
            weightCategories={this.props.productConfiguration.getFlatWeightCategories()}
            onUpdate={this.props.onUpdate}
            isFromStep3={false}
            productConfiguration={productConfiguration}
            quoteProductConfiguration={quoteProductConfiguration}
            onAddCoupler={onAddCoupler}
            onloadSharedDocuments={onloadSharedDocuments}
          />
          <ReviewQuoteCouplerDecisions
            quote={quote}
            productConfiguration={productConfiguration}
            quoteProductConfiguration={quoteProductConfiguration}
            onQuoteUpdated={onUpdate}
            onAddCoupler={onAddCoupler}
            onloadSharedDocuments={onloadSharedDocuments}
            machines={machines}
          />
        </div>
      </div>
    );
  }
}
